var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.tags.length > 0
    ? _c(
        "div",
        { staticClass: "post-tags text-muted small" },
        [
          _vm._v("\n    Từ khóa:\n    "),
          _vm._l(_vm.tags, function (tag) {
            return _c(
              "a",
              {
                staticClass: "badge badge-light mr-1",
                attrs: {
                  href: _vm.$root.url("post_tag", {
                    slug: tag.slug,
                    id: tag.id,
                  }),
                },
              },
              [_vm._v(_vm._s(tag.name))]
            )
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }